import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { getDataLayer } from "../trackingHelper";

export function sharedCartTracking(state: ApplicationState, cart?: Readonly<Cart>) {
    const dataLayerProducts: any[] = [];
    cart?.cartLines?.forEach(cartLine => {
        let productCondition = "";
        if (cartLine.productId) {
            const productData = getProductState(state, cartLine.productId).value;
            productCondition = productData?.properties?.condition || cartLine?.properties?.cartLineCondition;
        }
        dataLayerProducts.push({
            name: cartLine.shortDescription,
            id: cartLine.erpNumber,
            price: cartLine?.pricing?.actualPrice,
            quantity: cartLine.qtyOrdered,
            brand: cartLine?.properties?.cartLineBrandName,
            condition: productCondition,
            category: cartLine?.properties?.cartlineCategoryName,
            list: cartLine?.properties?.productSourceActionField || "",
            position: cartLine?.properties?.productListPosition || "",
        });
    });
    const dataLayer = getDataLayer();
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: "shareCart",
        ecommerce: {
            currencyCode: state.context.session.currency?.currencyCode,
            add: {
                actionField:
                {
                    list: "Cart",
                    action: "click",
                },
                products: dataLayerProducts
            },
        },
    });
}

export default sharedCartTracking;